import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const GalleryPage = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState<number | null>(null);

  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const images = [
     {
      src: '/images/CPR-Training-small-1-768x518.jpg',
      alt: 'CPR Training',
      category: 'Training'
    },
    {
      src: '/images/13-1-768x859.jpg',
      alt: 'Program Activity',
      category: 'Activities'
    },
    {
      src: '/images/11-1-768x859.jpg',
      alt: 'Group Activity',
      category: 'Activities'
    },
    {
      src: '/images/12-1-768x859.jpg',
      alt: 'Training Session',
      category: 'Training'
    },
    {
      src: '/images/1cdc0a73-32f2-4f93-b324-c81707d21c63.jpg',
      alt: 'Participant',
      category: 'Community'
    },
    {
      src: '/images/ProgramMember01.jpg',
      alt: 'Program Member',
      category: 'Community'
    },
    {
      src: '/images/9b3cb6ec-cb95-4bf8-a6e1-bdca5884af77.jpg',
      alt: 'Activity',
      category: 'Activities'
    },
    {
      src: '/images/d1a3198a-5ca0-4e29-9583-9033243bcf55.jpg',
      alt: 'Training',
      category: 'Training'
    },
  {
    src: '/images/03/CPR-Training-small.jpg',
    alt: 'CPR Training Session',
    category: 'Training'
  },
  {
    src: '/images/03/13.jpg',
    alt: 'Program Activity 13',
    category: 'Activities'
  },
  {
    src: '/images/03/11.jpg',
    alt: 'Program Activity 11',
    category: 'Activities'
  },
  {
    src: '/images/03/12.jpg',
    alt: 'Program Activity 12',
    category: 'Activities'
  },
  {
    src: '/images/03/10.jpg',
    alt: 'Program Activity 10',
    category: 'Activities'
  },
  {
    src: '/images/03/19.jpg',
    alt: 'Program Activity 19',
    category: 'Activities'
  },
  {
    src: '/images/03/18.jpg',
    alt: 'Program Activity 18',
    category: 'Activities'
  },
  {
    src: '/images/03/d1a3198a-5ca0-4e29-9583-9033243bcf55.jpg',
    alt: 'Vocational Training',
    category: 'Training'
  },
  {
    src: '/images/03/17.jpg',
    alt: 'Program Activity 17',
    category: 'Activities'
  },
  {
    src: '/images/03/8.jpg',
    alt: 'Program Activity 8',
    category: 'Activities'
  },
  {
    src: '/images/03/6.jpg',
    alt: 'Program Activity 6',
    category: 'Activities'
  },
  {
    src: '/images/03/5.jpg',
    alt: 'Program Activity 5',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2024-08-08-09-32-15.jpg',
    alt: 'Community Event August 2024',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2024-08-13-09-29-36.jpg',
    alt: 'Community Event August 2024',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2024-08-13-13-15-08.jpg',
    alt: 'Community Member Photo',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2024-08-20-11-32-59.jpg',
    alt: 'Program Participant',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2024-08-23-09-02-55.jpg',
    alt: 'Training Session August',
    category: 'Training'
  },
  {
    src: '/images/04/PHOTO-2024-09-13-11-38-15.jpg',
    alt: 'Event Photo September',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2024-10-07-12-11-08.jpg',
    alt: 'Event Photo October',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2024-11-15-11-29-14.jpg',
    alt: 'Program Activity November',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2024-11-27-14-50-51.jpg',
    alt: 'Community Gathering November',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2025-01-24-10-26-12.jpg',
    alt: 'Event Photo January 2025',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2025-02-14-12-33-03.jpg',
    alt: 'Valentine Event February',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2025-03-07-11-01-14.jpg',
    alt: 'Program Activity March',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2025-03-28-12-51-29.jpg',
    alt: 'Spring Training Session',
    category: 'Training'
  },
  {
    src: '/images/04/PHOTO-2025-03-17-09-57-03.jpg',
    alt: 'Member Photo March',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2025-04-02-11-48-16.jpg',
    alt: 'Recent Activity April',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2025-04-02-11-48-16_1.jpg',
    alt: 'Recent Activity April Variant',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2025-04-03-11-46-20.jpg',
    alt: 'April Program Photo',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2025-04-03-11-46-22.jpg',
    alt: 'April Program Photo 2',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2022-10-13-09-45-15.jpg',
    alt: 'Archive Photo 2022',
    category: 'Archive'
  },
  {
    src: '/images/04/PHOTO-2023-04-14-12-44-28.jpg',
    alt: 'Archive Photo 2023',
    category: 'Archive'
  },
  {
    src: '/images/04/PHOTO-2023-06-07-09-42-46.jpg',
    alt: 'Summer Activity 2023',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2023-06-14-15-54-54.jpg',
    alt: 'Summer Activity Photo',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2023-06-22-10-21-51.jpg',
    alt: 'Program Session June',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2023-06-30-11-46-55.jpg',
    alt: 'Member Photo June',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2023-10-31-13-28-52.jpg',
    alt: 'October Event Photo',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2023-11-02-09-51-09.jpg',
    alt: 'November Program Activity',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2023-11-30-09-50-29.jpg',
    alt: 'Winter Activity Session',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2023-11-30-09-50-37.jpg',
    alt: 'Winter Activity Photo',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2024-03-12-09-45-53.jpg',
    alt: 'March Activity 2024',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2024-03-26-10-52-50.jpg',
    alt: 'Spring Session 2024',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2024-03-29-10-41-23.jpg',
    alt: 'Member Photo March',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2024-04-04-12-40-38.jpg',
    alt: 'April Activity Session',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2024-04-26-10-40-34.jpg',
    alt: 'April Training Session',
    category: 'Training'
  },
  {
    src: '/images/04/PHOTO-2024-04-30-11-06-10.jpg',
    alt: 'Community Member April',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2024-05-14-10-50-37.jpg',
    alt: 'May Program Activity',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2024-05-20-11-03-36.jpg',
    alt: 'Member Photo May',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2024-05-21-11-09-45.jpg',
    alt: 'May Training Photo',
    category: 'Training'
  },
  {
    src: '/images/04/PHOTO-2024-05-28-12-06-48.jpg',
    alt: 'Community Event May',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2024-06-03-12-34-08.jpg',
    alt: 'June Activity Session',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2024-06-05-10-00-51.jpg',
    alt: 'Summer Training Session',
    category: 'Training'
  },
  {
    src: '/images/04/PHOTO-2024-06-10-12-45-54.jpg',
    alt: 'Member Photo June',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2024-06-27-11-51-11.jpg',
    alt: 'June Community Photo',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2024-06-27-11-51-12.jpg',
    alt: 'June Community Photo 2',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2024-07-02-11-10-37.jpg',
    alt: 'July Program Activity',
    category: 'Activities'
  },
  {
    src: '/images/04/PHOTO-2024-07-24-09-00-48.jpg',
    alt: 'Member Photo July',
    category: 'Community'
  },
  {
    src: '/images/04/PHOTO-2024-07-24-11-01-34.jpg',
    alt: 'July Training Session',
    category: 'Training'
  },
  {
    src: '/images/04/PHOTO-2024-07-24-13-55-38.jpg',
    alt: 'July Event Photo',
    category: 'Community'
  }
];
 

  const [filter, setFilter] = useState('All');
  const categories = ['All', 'Training', 'Activities', 'Community'];

  const filteredImages = filter === 'All' 
    ? images 
    : images.filter(img => img.category === filter);

  return (
    <div className="min-h-screen bg-white">
      {/* Top Bar */}
      <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white py-3 px-4">
        <div className="max-w-7xl mx-auto flex flex-wrap justify-between items-center text-sm gap-4">
          <div className="flex items-center gap-6 flex-wrap">
            <a href="tel:323-727-5033" className="flex items-center gap-2 hover:text-teal-400 transition-colors cursor-pointer">
              <i className="ri-phone-line"></i>
              <span className="font-medium">323-727-5033</span>
            </a>
            <div className="flex items-center gap-2 text-gray-300">
              <i className="ri-map-pin-line"></i>
              <span>204 S Atlantic Blvd. Los Angeles, CA 90022</span>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <a href="#" className="w-8 h-8 flex items-center justify-center hover:text-teal-400 transition-colors cursor-pointer" aria-label="Facebook">
              <i className="ri-facebook-fill text-lg"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center hover:text-teal-400 transition-colors cursor-pointer" aria-label="Twitter">
              <i className="ri-twitter-fill text-lg"></i>
            </a>
            <a href="#" className="w-8 h-8 flex items-center justify-center hover:text-teal-400 transition-colors cursor-pointer" aria-label="YouTube">
              <i className="ri-youtube-fill text-lg"></i>
            </a>
          </div>
        </div>
      </div>

      {/* Navigation */}
      <nav className={`sticky top-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-lg' : 'bg-white shadow-sm'}`}>
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex justify-between items-center">
            <Link to="/" className="flex-shrink-0">
              <img 
                src="/images/logo-01.webp" 
                alt="Choix Vocational Services" 
                className="h-16 w-auto"
              />
            </Link>
            
            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center gap-8">
              <Link to="/" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap">Home</Link>
              <Link to="/#about" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap">About</Link>
              <Link to="/#program" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap">Programs</Link>
              <Link to="/#services" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap">Services</Link>
              <Link to="/gallery" className="text-teal-600 hover:text-teal-700 transition-colors font-medium whitespace-nowrap">Gallery</Link>
              <Link to="/#contact" className="text-gray-700 hover:text-teal-600 transition-colors font-medium whitespace-nowrap">Contact</Link>
            </div>

            {/* Mobile Menu Button */}
            <button 
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              className="lg:hidden w-10 h-10 flex items-center justify-center text-gray-700 cursor-pointer"
              aria-label="Toggle menu"
            >
              <i className={`${mobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {mobileMenuOpen && (
            <div className="lg:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
              <div className="flex flex-col gap-4">
                <Link to="/" className="text-gray-700 hover:text-teal-600 transition-colors font-medium">Home</Link>
                <Link to="/#about" className="text-gray-700 hover:text-teal-600 transition-colors font-medium">About</Link>
                <Link to="/#program" className="text-gray-700 hover:text-teal-600 transition-colors font-medium">Programs</Link>
                <Link to="/#services" className="text-gray-700 hover:text-teal-600 transition-colors font-medium">Services</Link>
                <Link to="/gallery" className="text-teal-600 hover:text-teal-700 transition-colors font-medium">Gallery</Link>
                <Link to="/#contact" className="text-gray-700 hover:text-teal-600 transition-colors font-medium">Contact</Link>
              </div>
            </div>
          )}
        </div>
      </nav>

      {/* Gallery Header */}
      <section className="py-20 px-4 bg-gradient-to-br from-teal-50 to-cyan-50">
        <div className="max-w-7xl mx-auto text-center">
          <div className="inline-block mb-4">
            <span className="text-teal-600 font-semibold text-sm uppercase tracking-wider bg-white px-5 py-2 rounded-full shadow-sm">Our Community</span>
          </div>
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">Photo Gallery</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            Browse through our collection of memorable moments showcasing the positive impact we make in our community every day
          </p>
        </div>
      </section>

      {/* Filter Buttons */}
      <section className="py-8 px-4 bg-white border-b border-gray-200 sticky top-[88px] z-40">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-wrap justify-center gap-3">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setFilter(category)}
                className={`px-6 py-3 rounded-lg font-semibold transition-all whitespace-nowrap cursor-pointer ${
                  filter === category
                    ? 'bg-teal-600 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 px-4 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {filteredImages.map((image, index) => (
              <div 
                key={index}
                onClick={() => setSelectedImage(index)}
                className="relative aspect-square rounded-2xl overflow-hidden group cursor-pointer shadow-md hover:shadow-2xl transition-all hover:-translate-y-1"
              >
                <img 
                  src={image.src}
                  alt={image.alt}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                <div className="absolute bottom-0 left-0 right-0 p-6 text-white transform translate-y-full group-hover:translate-y-0 transition-transform">
                  <p className="font-semibold text-lg mb-1">{image.alt}</p>
                  <span className="text-sm text-teal-300">{image.category}</span>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox Modal */}
      {selectedImage !== null && (
        <div 
          className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4"
          onClick={() => setSelectedImage(null)}
        >
          <button
            onClick={() => setSelectedImage(null)}
            className="absolute top-4 right-4 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-all cursor-pointer"
            aria-label="Close"
          >
            <i className="ri-close-line text-2xl"></i>
          </button>
          
          <button
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImage(selectedImage > 0 ? selectedImage - 1 : filteredImages.length - 1);
            }}
            className="absolute left-4 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-all cursor-pointer"
            aria-label="Previous"
          >
            <i className="ri-arrow-left-line text-2xl"></i>
          </button>

          <button
            onClick={(e) => {
              e.stopPropagation();
              setSelectedImage(selectedImage < filteredImages.length - 1 ? selectedImage + 1 : 0);
            }}
            className="absolute right-4 w-12 h-12 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-full text-white transition-all cursor-pointer"
            aria-label="Next"
          >
            <i className="ri-arrow-right-line text-2xl"></i>
          </button>

          <div className="max-w-5xl w-full" onClick={(e) => e.stopPropagation()}>
            <img 
              src={filteredImages[selectedImage].src}
              alt={filteredImages[selectedImage].alt}
              className="w-full h-auto rounded-lg"
            />
            <div className="text-center mt-4">
              <h3 className="text-white text-2xl font-bold mb-2">{filteredImages[selectedImage].alt}</h3>
              <span className="text-teal-400 text-lg">{filteredImages[selectedImage].category}</span>
            </div>
          </div>
        </div>
      )}

      {/* Footer */}
      <footer className="bg-gradient-to-br from-gray-900 to-gray-800 text-white py-20 px-4">
        <div className="max-w-7xl mx-auto">
          <div className="grid md:grid-cols-4 gap-12 mb-16">
            {/* About Column */}
            <div className="md:col-span-2">
              <img 
                src="/images/logo-01.webp" 
                alt="Choix Vocational Services" 
                className="h-16 w-auto mb-6 brightness-0 invert"
              />
              <p className="text-gray-300 leading-relaxed mb-6 text-lg">
                Empowering individuals with disabilities through personalized support, training, and comprehensive vocational services since 2012.
              </p>
              <div className="flex items-center gap-3">
                <a href="#" className="w-11 h-11 flex items-center justify-center bg-white/10 hover:bg-teal-600 rounded-lg transition-all cursor-pointer" aria-label="Facebook">
                  <i className="ri-facebook-fill text-xl"></i>
                </a>
                <a href="#" className="w-11 h-11 flex items-center justify-center bg-white/10 hover:bg-teal-600 rounded-lg transition-all cursor-pointer" aria-label="Twitter">
                  <i className="ri-twitter-fill text-xl"></i>
                </a>
                <a href="#" className="w-11 h-11 flex items-center justify-center bg-white/10 hover:bg-teal-600 rounded-lg transition-all cursor-pointer" aria-label="YouTube">
                  <i className="ri-youtube-fill text-xl"></i>
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-xl font-bold mb-6">Quick Links</h3>
              <div className="flex flex-col gap-3">
                <Link to="/" className="text-gray-300 hover:text-teal-400 transition-colors">Home</Link>
                <Link to="/#about" className="text-gray-300 hover:text-teal-400 transition-colors">About Us</Link>
                <Link to="/#program" className="text-gray-300 hover:text-teal-400 transition-colors">Programs</Link>
                <Link to="/#services" className="text-gray-300 hover:text-teal-400 transition-colors">Services</Link>
                <Link to="/gallery" className="text-gray-300 hover:text-teal-400 transition-colors">Gallery</Link>
                <Link to="/#contact" className="text-gray-300 hover:text-teal-400 transition-colors">Contact</Link>
              </div>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-xl font-bold mb-6">Contact Info</h3>
              <div className="flex flex-col gap-4 text-gray-300">
                <div className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-teal-400 mt-1 text-xl"></i>
                  <span className="leading-relaxed">204 S Atlantic Blvd.<br/>Los Angeles, CA 90022</span>
                </div>
                <div className="flex items-center gap-3">
                  <i className="ri-phone-line text-teal-400 text-xl"></i>
                  <a href="tel:323-727-5033" className="hover:text-teal-400 transition-colors cursor-pointer font-medium">323-727-5033</a>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="border-t border-gray-700 pt-8 flex flex-wrap justify-between items-center gap-4 text-sm text-gray-400">
            <div>
              © 2012-2025 Choix Vocational Services. All rights reserved.
            </div>
            <div>
              <a href="https://readdy.ai/?ref=logo" className="hover:text-teal-400 transition-colors cursor-pointer" target="_blank" rel="noopener noreferrer">Website Builder</a>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default GalleryPage;
